import { Minus, Plus } from "lucide-react";
import { useTranslation } from "react-i18next";
import { cn } from "../lib/utils";

/**
 * − N + miqdor stepper. Qiymat string sifatida saqlanadi (kasr miqdorlar uchun),
 * tugmalar 1 ga oshiradi/kamaytiradi, lekin maydonni qo'lda ham tahrirlash mumkin.
 */
export function QtyStepper({
  value,
  onChange,
  disabled,
  className,
  max,
}: {
  value: string;
  onChange: (v: string) => void;
  disabled?: boolean;
  className?: string;
  /** Berilsa — miqdor bu chegaradan oshmaydi (masalan sotuvda ombor ostatkasi). */
  max?: number;
}) {
  const { t } = useTranslation("ombor");
  const n = Number(value) || 0;
  const clamp = (x: number) => (max != null ? Math.min(x, max) : x);
  const step = (delta: number) => {
    const next = clamp(Math.max(0, Math.round((n + delta) * 1000) / 1000));
    onChange(String(next));
  };
  const handleInput = (raw: string) => {
    if (max != null) {
      const num = Number(raw);
      if (Number.isFinite(num) && num > max) {
        onChange(String(max));
        return;
      }
    }
    onChange(raw);
  };

  return (
    <div className={cn("inline-flex h-8 items-stretch rounded-md border border-input bg-background", className)}>
      <button
        type="button"
        onClick={() => step(-1)}
        disabled={disabled || n <= 0}
        className="flex w-7 items-center justify-center rounded-l-md text-muted-foreground hover:bg-accent hover:text-foreground disabled:opacity-40"
        aria-label={t("shared.qty.decrease")}
      >
        <Minus className="size-3.5" />
      </button>
      <input
        type="text"
        inputMode="decimal"
        value={value}
        onChange={(e) => handleInput(e.target.value)}
        disabled={disabled}
        className="w-10 border-x border-input bg-transparent text-center text-sm tabular-nums outline-none focus:ring-1 focus:ring-ring disabled:opacity-50"
      />
      <button
        type="button"
        onClick={() => step(1)}
        disabled={disabled || (max != null && n >= max)}
        className="flex w-7 items-center justify-center rounded-r-md text-muted-foreground hover:bg-accent hover:text-foreground disabled:opacity-40"
        aria-label={t("shared.qty.increase")}
      >
        <Plus className="size-3.5" />
      </button>
    </div>
  );
}
